import CModal from '../CModal';
import { IconEdit } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Input, message } from 'antd';
import { useState } from 'react';
import { apiV1 } from '../../utils/apiClient';
import { CustomersGroup } from '@next-is-free-monorepo/next-is-free-types';

interface RenameCustomersGroupsModalProps {
  group: CustomersGroup;
  open: boolean,
  onClose: ()=>void
}

const RenameCustomersGroupsModal = ({ group, open, onClose }: RenameCustomersGroupsModalProps) => {

  const [name, setName] = useState(group.name);
  const queryClient = useQueryClient()

  const renameGroup = {
    mutationFn: async () => (
      await apiV1.put(`/shop/customers/groups/${group.id}`, { ...group, name: name })
    ),
    onSuccess: async ()=>{
      await queryClient.invalidateQueries({queryKey: ['customers-groups']})
      onClose();
      message.success('Nome aggiornato')
    }
  };

  return (
    <CModal disabled={!name} title={'Rinomina gruppo'} open={open} onClose={onClose} icon={<IconEdit />} mutationOptions={renameGroup} confirmButtonText={'Rinomina'}>
      <p className={'mb-5 text-slate-500'}>Scegli un nome per questo gruppo</p>
      <Input value={name} autoFocus onChange={(e) => setName(e.target.value)} size={'large'} placeholder={'Nome gruppo'} />
    </CModal>
  );
};
export default RenameCustomersGroupsModal;
